import { SVGProps } from 'react';

export const Error = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='56'
    height='46'
    viewBox='0 0 56 46'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M16.6323 13.4292L21.6713 19.1047'
      strokeWidth='2.21009'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M21.9617 13.7227L16.3413 18.811'
      strokeWidth='2.21009'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M33.8916 13.4292L38.9307 19.1047'
      strokeWidth='2.21009'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M39.2215 13.7227L33.6011 18.811'
      strokeWidth='2.21009'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M47.2904 2H8.71003C6.18156 2 4.13184 4.06979 4.13184 6.62301V31.343C4.13184 33.8962 6.18156 35.966 8.71003 35.966H47.2904C49.8188 35.966 51.8686 33.8962 51.8686 31.343V6.62301C51.8686 4.06979 49.8188 2 47.2904 2Z'
      strokeWidth='2.21009'
      strokeMiterlimit='10'
    />
    <path
      d='M36.6609 7.37305H41.7449C44.2734 7.37305 46.3231 9.44283 46.3231 11.9961V26.1516C46.3231 28.7049 44.2734 30.7746 41.7449 30.7746H14.2554C11.727 30.7746 9.67725 28.7049 9.67725 26.1516V11.9961C9.67725 9.44283 11.727 7.37305 14.2554 7.37305H31.52'
      strokeWidth='2.21009'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path d='M8.70996 2H47.2903' strokeWidth='2.21009' strokeMiterlimit='10' />
    <path
      d='M19.1516 43.9998H4.68247C2.92485 43.9998 1.5 42.561 1.5 40.7862V39.1794C1.5 37.4046 2.92485 35.9658 4.68247 35.9658H51.3175C53.0752 35.9658 54.5 37.4046 54.5 39.1794V40.7862C54.5 42.561 53.0752 43.9998 51.3175 43.9998H22.7681'
      strokeWidth='2.21009'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M18.1118 26.3716C18.2121 26.1525 27.4435 19.0677 37.4513 26.3716'
      strokeWidth='2.21009'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
  </svg>
);
